import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import {
  productDeleteRequest,
  productResetState,
  productViewAllRequest,
} from "../../../redux/products/ProductAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import { styles, filterStyles } from "../../components/LoginStyles";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import { APP_LINK } from "../../global/MenuItems";
import Pagination from "../../constant/CommonPagenation";
import DeleteDialog from "../../constant/commonDeleteDialogBox";
import { WholesalerImageCell } from "../../constant/imageList";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/admin/sub-brand/edit/${user?.id}`);
  };

  const handleView = () => {
    navigate(`/admin/sub-brand/view/${user?.id}`, {
      state: {
        vendor: user,
      },
    });
    handleClose();
  };

  const handleDelete = () => {
    onDelete(user?.id);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleView} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const ProductList = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [emptyList, setEmptyList] = useState([]);
  const dispatch = useDispatch();
  const productViewAllState = useSelector(
    (state) => state?.product?.viewAllProducts || {}
  );
  const productList = productViewAllState?.data?.data || [];
  const totalRecords = productViewAllState?.data?.totalRecords || 0;
  const productPageSize = productViewAllState?.pageSize || 10;
  const navigate = useNavigate();
  //search
  const [searchTerm, setSearchTerm] = useState("");

  const productDeleteState = useSelector(
    (state) => state?.product?.deleteProduct || {}
  );

  const columns = (handleDeleteRow) => [
    {
      field: "product_image",
      headerName: "Sub Brand Image",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return (
          <WholesalerImageCell
            imageUrl={params.value}
            altText={params.row?.product_name}
          />
        );
      },
    },
    {
      field: "product_code",
      headerName: "Sub Brand Code",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Not Provided",
    },
    {
      field: "brand_id",
      headerName: "Brand Name",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params.row?.Brand?.brand_name || "No Name Available";
      },
    },
    {
      field: "product_name",
      headerName: "Sub Brand Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Name Available",
    },
    {
      field: "description",
      headerName: "Description",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Description Available",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params?.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("action"),
      renderCell: (params) => (
        <ActionMenu user={params.row} onDelete={handleDeleteRow} />
      ),
    },
  ];

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      const payload = {
        pageNo: currentPage,
        search_key: searchTerm?.trim() || "",
        pagination_required: true,
      };
      dispatch(productViewAllRequest(payload));
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, currentPage, dispatch]);

  useEffect(() => {
    if (productViewAllState?.success) {
      setRows(productList);
    } else {
      setRows(emptyList);
    }
  }, [productViewAllState, productList]);

  useEffect(() => {
    if (productDeleteState?.success) {
      const newPage =
        rows.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

      const payload = {
        pageNo: newPage,
        search_key: searchTerm?.trim() || "",
        pagination_required: true,
      };

      dispatch(productViewAllRequest(payload));
      dispatch(productResetState());
      setCurrentPage(newPage);
    }
  }, [productDeleteState?.success]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setProductToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(productDeleteRequest(productToDelete));
    setProductToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handeladdproduct = () => {
    navigate(APP_LINK.ADDPRODUCT);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Product Name Asc":
        sortedRows.sort((a, b) =>
          a?.product_name?.localeCompare(b?.product_name)
        );
        break;
      case "Sort by Product Name Desc":
        sortedRows.sort((a, b) =>
          b?.product_name?.localeCompare(a?.product_name)
        );
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={7} md={7} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Sub Brand Management</h1>
            <p>Here is the complete list of Sub Brands data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handeladdproduct}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Asc")}
          >
            Product Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Product Name Desc")}
          >
            Product Name Z-A
          </MenuItem>
        </Menu>
        <Paper>
          <Box>
            {/*search*/}
            <Box display="flex" justifyContent="flex-end" mb={2}>
              <input
                type="text"
                placeholder="Search by brand/sub-brand name or code..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{
                  padding: "8px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  width: "300px",
                }}
              />
            </Box>
            {productViewAllState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={productViewAllState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            )}
            {productDeleteState?.inProgress && (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1001}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={productDeleteState?.inProgress}
                    size={50}
                    color="#d32f2f"
                  />
                </Box>
              </Box>
            )}

            {productViewAllState?.inProgress ? (
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(255, 255, 255, 0.5)"
                zIndex={1000}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircleLoader
                    loading={productViewAllState?.inProgress}
                    size={50}
                    color="#0458d3"
                  />
                </Box>
              </Box>
            ) : (
              <CustomDataGrid
                rows={rows}
                columns={columns(handleDeleteRow)}
                pageSize={productPageSize}
                pagination={true}
                rowHeight={70}
                onSelectionModelChange={(newSelection) => {
                  setSelection(newSelection);
                }}
                sx={filterStyles.modalHeight(rows)}
              />
            )}
            {selection.length > 0 && (
              <div>
                <h2>Selected Rows:</h2>
                {selection.map((id) => (
                  <div key={id}>
                    {rows.find((row) => row.id === id).CustomerName}
                  </div>
                ))}
              </div>
            )}
          </Box>
        </Paper>
        <Box mt={2}>
          <Grid>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={totalRecords}
              pageSize={productPageSize}
            />
          </Grid>
        </Box>
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
      </StyledContainer>
    </>
  );
};

export default ProductList;
